import {
    INSTITUTION_SET_CI_INFO
  } from "../constants/ActionTypes";

  export const setInstitutionInfo = (institutionInfo) => {
    return { type: INSTITUTION_SET_CI_INFO, payload : institutionInfo };
  };